import { mockXprops } from '@digital-dealer/zoid-definitions';

mockXprops();
